import Vue from 'vue'
import VueRouter from 'vue-router'
import config from "@/config";
import OrderComplete from "@/components/OrderComplete";
import OrderFail from "@/components/OrderFail";
import MagicLink from "../desktopViews/MagicLink.vue";
import ChatView from "@/desktopViews/ChatView.vue";

Vue.use(VueRouter);

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// @todo check if is mobile
const isMobile = mobileCheck();



const cities = [
    {name: 'nice', lat: '43.70113649085292, 7.26997672452728'},
    {name: 'antibes', lat: '43.58064764248454, 7.122009689779705'},
    {name: 'pau', lat: '43.2958287905817, -0.37049056886609594'},
    {name: 'nantes', lat: '47.21625789352936, -1.5552201670131216'},
    {name: 'bordeaux', lat: '44.84248365823506, -0.5819234849326146'},
    {name: 'lyon', lat: '45.75956775987068, 4.835469573027499'},
    {name: 'rennes', lat: '48.11706210185529, -1.679519666588309'},
    {name: 'reims', lat: '49.25909977475547, 4.029020072829324'},
    {name: 'rouen', lat: '49.44300422482796, 1.0982247183920126'},
    {name: 'marseille', lat: '43.30158484093762, 5.389627183504566'},
    {name: 'lille', lat: '50.624655748039686, 3.0671730248560833'},
    {name: 'paris', lat: '48.8558594429121, 2.347029144331989'},
    {name: 'toulouse', lat: '43.60510832046079, 1.4469274996012689'},
    {name: 'limoges', lat: '45.83597105221413, 1.2500443920728184'},
    {name: 'montpellier', lat: '43.610862974765936, 3.8751999504460106'},
    {name: 'menton', lat: '43.77428251727992, 7.497527158416144'},
    {name: 'Cannes', lat: '43.55317209323318, 7.017262709186371'},
    {name: 'aix-en-provence', lat: '43.53264771340917, 5.4507443772967985'},
    {name: 'poitiers', lat: '46.57966725915483, 0.3419346125116374'},
    {name: 'tours', lat: '47.389607932393204, 0.6887593837973266'},
    {name: 'le-mans', lat: '48.00528269651705, 0.2012352262025911'},
    {name: 'la-rochelle', lat: '46.16047881185292, -1.1512394042198764'},
    {name: 'embrun', lat: '44.56439549097224, 6.4913571276338216'},
    {name: 'ajaccio', lat: '41.91937902699375, 8.73839736915435'},
    {name: 'strasbourg', lat: '48.57245258124948, 7.7517829116659716'},
    {name: 'saint-etienne', lat: '45.43929408061154, 4.388627437079517'},
    {name: 'toulon', lat: '43.12520224865236, 5.927767734868514'},
    {name: 'le-havre', lat: '49.495806508301285, 0.10166781857520636'},
    {name: 'grenoble', lat: '45.18760415159206, 5.72155127450597'},
    {name: 'dijon', lat: '47.32963757453549, 5.048010577598555'},
    {name: 'angers', lat: '47.47097169612099, -0.5529883553427101'},
    {name: 'nimes', lat: '43.83183820292129, 4.356249199962849'},
    {name: 'brest', lat: '48.386949186843054, -4.486577499496904'},
    {name: 'metz', lat: '49.11751536144145, 6.174608935683992'},
    {name: 'besançon', lat: '47.239627772338125, 6.027673573765697'},
    {name: 'roubaix', lat: '50.69246917252969, 3.1781578894838023'},
    {name: 'colmar', lat: '48.08142267082292, 7.356306746376982'},
    {name: 'arcachon', lat: '44.652440579345715, -1.179304296373649'},
    {name: 'draveil', lat: '48.68464115696559, 2.408897685922132'},
];



function convertCitiesToRouter(cities) {
    return cities.map(city => {
        return {
            path: '/' + city.name.toLowerCase(),
            component: function () {
                const lat = city.lat.split(',')[0].trim();
                const lng = city.lat.split(',')[1].trim();
                location.href = `/?lat=${lat}&lng=${lng}&addressName=${city.name}`;
            }
        }
    });
}





if(location.host === config.mainHost || location.host === 'delicity.com' || location.host === 'localhost:8080'){
    var routes = [
        {
            path: '/',
            name: 'catalog',
            meta: {title: 'Delicity : Nos restaurants'},
            component: function (){
                if(isMobile) return import('@/mobileViews/Home');
                else return import('@/desktopViews/Home');
            }
        },
        ...convertCitiesToRouter(cities),

        {
            path: '/basilic-and-co-nice-gare-du-sud',
            redirect: '/basilicandco-nice'
        },


        {
            path: '/chat',
            component: ChatView
        },
        {
            path: '/user/:username',
            component: function (){
                let username = window.location.pathname.split('/')[2];
                location.href = 'https://s.delicity.com/u/'+username;
            },
        },
        {
            path: '/:slug/booking',
            component: function (){
                let slug = window.location.pathname.split('/')[1];
                location.href = 'https://booking.delicity.com/'+slug;
            },
        },
        {
            path: '/merchant/un/:placeId',
            component: function (){
                let placeId = window.location.pathname.split('/')[3];
                location.href = 'https://s.delicity.com/merchant/un/'+placeId;
            },
        },
        {
            path: '/signin/magicLink_app',
            component: MagicLink
        },


        {
            path: '/order_complete',
            name: 'order_complete',
            meta: {
                title: 'Commande validée'
            },
            component: OrderComplete,
        },
        {
            path: '/order_fail',
            name: 'order_fail',
            meta: {
                title: 'Erreur de paiement'
            },
            component: OrderFail,
        },
        {
            path: '/categories',
            name: 'categories',
            meta: {
                title: 'Categories'
            },
            component: function (){
                if(isMobile){
                    return import('@/mobileViews/Categories');
                }
                else{
                    return false;
                }
            }
        },
        {
            path: '/:merchantSlug/summary',
            name: 'summary',
            meta: {
                title: 'Delicity : Connexion'
            },
            component: function (){
                if(isMobile){
                    return false;
                }
                else{
                    return import('@/desktopViews/Summary');
                }
            }
        },
        {
            path: '/:merchantSlug/checkout/:orderToken/:shareToken?',
            name: 'checkout',
            meta: {
                title: 'Votre commande'
            },
            component: function (){
                if(isMobile){
                    return import('@/mobileViews/Checkout');
                }
                else{
                    return import('@/desktopViews/Checkout');
                }
            }
        },
        {
            path: '/ano_account',
            name: 'ano_account',
            meta: {
                title: 'Enregistrer votre compte'
            },
            component: function (){
                if(isMobile){
                    return import('@/mobileViews/Anonymous/AnonymousMigration');
                }
                else{
                    //return import('@/desktopViews/Checkout');
                }
            }
        },
        {
            path: '/ano_account/success',
            name: 'ano_account_success',
            meta: {
                title: 'Félicitations !'
            },
            component: function (){
                if(isMobile){
                    return import('@/mobileViews/Anonymous/AnonymousSuccess');
                }
                else{
                    //return import('@/desktopViews/Checkout');
                }
            }
        },
        {
            path: '/:merchantSlug',
            name: 'merchant',
            component: function (){
                if(isMobile){
                    return import('@/mobileViews/Merchant');
                }
                else{
                    return import('@/desktopViews/Merchant');
                }
            }
        }
    ]
}
else{
  var routes = [
    {
      path: '/checkout/:orderToken/:shareToken?',
      name: 'checkout',
      meta: {
        title: 'Votre commande'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Checkout');
        }
        else{
          return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account',
      name: 'ano_account',
      meta: {
        title: 'Enregistrer votre compte'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousMigration');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account/success',
      name: 'ano_account_success',
      meta: {
        title: 'Félicitations !'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousSuccess');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/',
      name: 'home',
      component: function (){
        if(isMobile){
          return import('@/mobileViews/MerchantHome');
        }
        else{
          return import('@/desktopViews/MerchantHome');
        }
      }
    },
    {
      path: '/order',
      name: 'merchant',
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Merchant');
        }
        else{
          return import('@/desktopViews/Merchant');
        }
      }
    },
    {
      path: '/summary',
      name: 'summary',
      meta: {
        title: 'Delicity : Connexion'
      },
      component: function (){
        if(isMobile){
          return false;
        }
        else{
          return import('@/desktopViews/Summary');
        }
      }
    },
    {
      path: '/*',
      redirect: '/order'
    }
  ]

}

const router = new VueRouter({
  mode: 'history',
  routes
});


export default router
